export default {
  props: {
    height: {
      type: String,
      default: '47vh'
    }
  }
}
